import { getCompanyContactDataById } from '../companyContacts/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { IOpportunityMSContact } from '@/types/opportunity/models'

const opportunityMSContactListData =
  undefined as unknown as IOpportunityMSContact[]

export const getOpportunityMSContactListData = getListDataFunctionFactory<
  IOpportunityMSContact[]
>({
  listData: opportunityMSContactListData,
  storageKey: 'opportunitymscontacts',
  getStartingListData: getStartingOpportunityMSContactListData,
})

export async function getOpportunityMSContactListDataByOMSId(id: TEntityId) {
  const listData = await getOpportunityMSContactListData()
  return listData.filter(
    (omsct: IOpportunityMSContact) => omsct.opportunityMasterService.id === id
  )
}

export async function getOpportunityMSContactDataById(
  id: TEntityId
): Promise<IOpportunityMSContact | undefined> {
  const listData = await getOpportunityMSContactListData()
  return listData.find((omsc: IOpportunityMSContact) => omsc.id === id)
}

export async function getStartingOpportunityMSContactListData(): Promise<
  IOpportunityMSContact[]
> {
  return [
    {
      id: 'XXOMSC0001',
      hrid: 'OMSC0001',
      opportunityMasterService: {
        id: 'XXOMS0005',
        label: 'DIA - Boston, Lake & Waltham',
      },
      contact: await getCompanyContactDataById('XXCCT0017')!,
      splitFraction: null,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
